<template>
    <div class="login">
        <div class="box">
            <div class="title">后台管理系统</div>
            <div class="input">
                <i class="el-icon-user"></i>
                <input type="text" v-model="account" :class="accountPlaceholder=='请输入账号'?'':'placeholder_style'"
                       :placeholder="accountPlaceholder" v-on:keyup.enter="login">
            </div>
            <div class="input">
                <i class="el-icon-lock"></i>
                <input type="password" v-model="password" :class="passwordPlaceholder=='请输入密码'?'':'placeholder_style'"
                       :placeholder="passwordPlaceholder" v-on:keyup.enter="login">
            </div>
            <button @click="login">登录</button>
        </div>
    </div>
</template>
<script>
    import {login} from '@/assets/js/api'

    export default {
        name: "login",
        data() {
            return {
                account: "",
                password: "",
                accountPlaceholder: '请输入账号',
                passwordPlaceholder: '请输入密码'
            }
        },
        methods: {
            // 获取数据
            login() {
                if (this.account == '') {
                    this.accountPlaceholder = '账户为必填'
                    return
                }
                if (this.password == '') {
                    this.passwordPlaceholder = '密码为必填'
                    return
                }
                login({account: this.account, password: this.password}).then((response) => {
                    console.log('11111---'+response.data.Code)
                    if (response.data.code == 0) {
                        sessionStorage.setItem('uKey', '1')
                        sessionStorage.setItem('name', 'admin')
                        this.$router.push('/Video')
                    }
                    else if (response.data.ReturnCode == 212) {
                        this.$message.error('账号密码错误');
                    }
                })
            },
        },
        created() {
        }
    };
</script>

<style lang="scss" scoped>
    .login {
        width: 100%;
        height: 100%;
        background: url('http://clouddn.yinchtv.com/FnX6XmF6stYdNRWSSeTZ-iaD5peF') no-repeat;
        background-size: cover;
        position: relative;
        .box {
            width: 550px;
            height: 352px;
            background: rgba(255, 255, 255, 1);
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .title {
                margin: 50px auto 40px;
                height: 25px;
                font-size: 18px;
                font-weight: 500;
                color: rgba(17, 17, 17, 1);
                line-height: 25px;
                text-align: center;
                width: 220px;
            }
            .input {
                height: 22px;
                padding: 24px 10px 0 5px;
                width: 440px;
                margin: 0 auto;
                border-bottom: 1px solid #DADCDF;
                i {
                    font-size: 17px;
                    padding: 0 12px 0 15px;
                    border-right: 1px solid #B1B1B1;
                    vertical-align: top;
                    margin-top: 2px;
                    color: rgba(153, 153, 153, 1);
                }
                input {
                    height: 100%;
                    padding-left: 12px;
                    color: rgba(153, 153, 153, 1);
                    font-size: 14px;
                }
            }
            .input:nth-child(2) {
                margin-top: 22px;
            }
            input {
                outline: none;
            }
            .placeholder_style::-webkit-input-placeholder { /* WebKit browsers */
                color: #FF5B6C;
            }
            .placeholder_style::-moz-placeholder { /* Mozilla Firefox 19+ */
                color: #FF5B6C;
            }
            .placeholder_style:-ms-input-placeholder { /* Internet Explorer 10+ */
                color: #FF5B6C;
            }
            button {
                display: block;
                text-align: center;
                width: 140px;
                height: 38px;
                line-height: 38px;
                /*background:rgba(80,197,217,1);*/
                background: rgba(201, 160, 108, 1);
                border-radius: 5px;
                margin: 30px auto 0;
                font-size: 14px;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
            }
        }
        ::-webkit-input-placeholder { /* WebKit browsers */
            color: rgba(153, 153, 153, 1);;
        }
        ::-moz-placeholder { /* Mozilla Firefox 19+ */
            color: rgba(153, 153, 153, 1);;
        }
        :-ms-input-placeholder { /* Internet Explorer 10+ */
            color: rgba(153, 153, 153, 1);;
        }
    }
</style>
